var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"message.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'message.all_messages' | translate}}</a></li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"message.create\">\n<a translate=\"message.menu.create\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['view']\" ui-sref-active=\"active\" ui-sref=\"message.duplicateMessage\">\n<a>{{'common.duplicates' | translate}} {{'common.message' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view><ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="message.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tnt_control/component/message/message.html
// module id = 2854
// module chunks = 1